const state = {
    object: {
        index: 0,
        modes: ['auto', 'zoom', '16:9', '4:3']
    }
};

const actions = {
    changeVideoAspectRatioIndex({commit, dispatch}, index) {
        commit('SET_INDEX', index);
    }
};

const mutations = {
    SET_INDEX(state, index) {
        state.object.index = index;
    }
};

export default {
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/video-aspect-ratio.js